import { useNavigate } from 'react-router-dom';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from './misc.module.scss';
import Footer from '../footer/Footer';
import { HomeIcon } from '@heroicons/react/24/solid';

export default function Kontakt() {

    //const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();
    //const auth = useSelector((state: RootState) => state.authSlice.auth);
    const navigate = useNavigate();

    return (
        <>
            <div className="max-w-7xl mx-auto px-4">
                <div className={styles.contentb}>
                    <div className={styles.wrapperb}>

                        {/*auth.isAuthCheckFinished === false &&
                        <><div>Lädt...</div></>
                    */}

                        <LandingpageHeader />

                        <div>

                            <button className="btn btn-dark" onClick={() => { navigate("/") }}><HomeIcon className="w-6 h-6 text-white-500" /></button>

                            <div style={{ marginTop: "5em" }}>
                                <h3 style={{ textAlign: "center" }}>Kontakt</h3>
                            </div>

                        </div >

                    </div >
                    <Footer />
                </div>
            </div >
        </>
    );
}
